import { prefetchListData } from "@store/slices/dataSlice";
import React, { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";

import { DATA_DETAIL_SEGMENT } from "@helpers/constants";

import { AppContext, Provider as AppProvider } from "./helpers/context";
import Data from "./pages/Data";
import HomeTable from "./pages/HomeTable";

type Props = {
  onRouteNotFound?: () => void;
};

function DataExplorerContent({ onRouteNotFound }: Props) {
  const { ready, setReady } = useContext(AppContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (setReady && !ready) {
      dispatch(prefetchListData(setReady) as any);
    }
  }, [ready, setReady, dispatch]);

  return (
    <Routes>
      <Route path={`/${DATA_DETAIL_SEGMENT}/:dataId/*`} element={<Data />} />
      <Route path="/:page?" element={<HomeTable />} />
      <Route
        path="*"
        element={
          onRouteNotFound ? <>{onRouteNotFound()}</> : <p>404 Not Found</p>
        }
      />
    </Routes>
  );
}

export default function DataExplorer({ onRouteNotFound }: Props) {
  return (
    <AppProvider>
      <DataExplorerContent onRouteNotFound={onRouteNotFound} />
    </AppProvider>
  );
}
